package kz.dentalcrm.app.core.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.confirm
import kotlinx.datetime.LocalDate
import kz.dentalcrm.app.core.ui.utils.MaskVisualTransformation
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource

@Composable
actual fun BirthDayDialog(
    defaultTime: LocalDate,
    onDismissRequest: () -> Unit,
    onDateSelected: (LocalDate) -> Unit,
) {
    val initialDigits = remember(defaultTime) {
        val d = defaultTime.day.toString().padStart(2, '0')
        val m = defaultTime.monthNumber.toString().padStart(2, '0')
        val y = defaultTime.year.toString()
        "$d$m$y"
    }
    var rawDigits by remember { mutableStateOf(initialDigits) }
    val parsedDate: LocalDate? = remember(rawDigits) {
        if (rawDigits.length == 8) {
            runCatching {
                val day = rawDigits.substring(0, 2).toInt()
                val month = rawDigits.substring(2, 4).toInt()
                val year = rawDigits.substring(4, 8).toInt()
                LocalDate(year, month, day)
            }.getOrNull()
        } else null
    }
    val isError = rawDigits.length == 8 && parsedDate == null

    Dialog(onDismissRequest = onDismissRequest) {
        Column(
            modifier = Modifier
                .widthIn(max = 400.dp)
                .wrapContentHeight()
                .background(
                    color = DefaultTheme.colors.surface,
                    shape = RoundedCornerShape(24.dp),
                )
                .padding(16.dp),
        ) {
            UITextInput(
                modifier = Modifier.fillMaxWidth(),
                label = "ДД/ММ/ГГГГ",
                defaultValue = initialDigits,
                isOnError = isError,
                errorText = "Неверный формат даты",
                isOnlyNumbers = true,
                maxLength = 8,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                visualTransformation = MaskVisualTransformation("##/##/####"),
                valueChanged = { rawDigits = it },
            )
            Spacer(modifier = Modifier.height(16.dp))
            UIButton(
                modifier = Modifier.fillMaxWidth(),
                text = stringResource(Res.string.confirm),
                enabled = parsedDate != null,
                onClick = {
                    parsedDate?.let { onDateSelected(it) }
                    onDismissRequest()
                },
            )
        }
    }
}
